<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">姓名</span>
         <el-input v-model.trim="name" placeholder="请输入" style="width: 150px;"/>
      </div>
      
	  <div class="dlblock-mb20 mr10">
	    <span class="pr5">创建时间</span>
	    <el-date-picker
	        v-model="createTime"
	        style="width: 180px;"
	        type="datetime"
	  			class="reset-clear"
	  			:clearable="false"
	  			 unlink-panels
	        value-format="yyyy-MM-dd HH:mm:ss"
	        start-placeholder="开始时间"
	        />
	  </div> 
	  
	  
	  	<div class="dlblock-mb20 mr10">
	    <span class="pr5">结束日期</span>
	    <el-date-picker
	      v-model="updateTime"
	  		  style="width: 180px;"
	      type="datetime"
	      :clearable="false"
	      unlink-panels
	      end-placeholder="结束时间"
	      value-format="yyyy-MM-dd HH:mm:ss"
	       />
	  </div> 
	  
      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="pages.page = 1; getHrFaceDatabasePageListFn()">
          搜索
        </el-button>
		
		<el-button type="primary" @click="editBtn(1)">
		  新增
		</el-button>
		
      </div>
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="name" label="姓名"></el-table-column>
	  <el-table-column align="center" prop="gender" label="性别"></el-table-column>
      <el-table-column align="center" prop="age" label="年龄"></el-table-column>
	  <el-table-column align="center"  label="图片">
	    <template slot-scope="{row}">
	      <el-image class="m-box-img" :src="row.pictureUrl" @click="editBtn(4,row)" lazy></el-image>
	    </template>
	  </el-table-column>
	  <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
	  <el-table-column align="center" prop="updateTime" label="更新时间"></el-table-column>
	  <el-table-column align="center" width="150" label="操作">
	    <template slot-scope="{row}">
	      <a class="glob-a"  @click="editBtn(2, row)">修改</a>
	      <a class="glob-a"  @click="editBtn(5, row)">删除</a> 
		  <a class="glob-a"  @click="editBtn(3, row)">人脸比对(1->N)</a> 
	    </template>
	  </el-table-column>
	</el-table>  
	  
    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>
	
	
	<!-- 新增编辑 -->
	  <el-dialog :title="editData.add === 1 ? '新增人脸' : '编辑人脸'" :visible.sync="editData.modal" width="600px">
	    <el-form label-width="140px">
	      <el-form-item label="姓名：">
	        <el-input v-model.trim="editData.name" placeholder="请输入姓名"/>
	      </el-form-item>
	      <el-form-item label="性别：">
				<el-select v-model="editData.gender" class="w150" placeholder="非必选" clearable>
				  <el-option v-for="(item, index) in genderList" :key="index" :label="item.name" :value="item.value"/>
				</el-select>
	      </el-form-item>
			<el-form-item label="年龄：">
			  <el-input v-model.trim="editData.age" placeholder="请输入年龄"/>
			</el-form-item>
			<el-form-item label="人脸图片：">
					<el-row>
					  <hrface-database-photo class="mr10 mb10" v-model="editData.pictureUrl" :id="hrFaceDatabaseId" :total="1"/>
					</el-row>
			</el-form-item>
	    </el-form>
	
	    <div slot="footer">
	      <el-button @click="editData.modal = false">取 消</el-button>
	      <el-button type="primary" @click="addBtn">确 定</el-button>
	    </div>
	  </el-dialog>
	  
	  <!-- 图片放大 -->
	  <el-dialog title="查看" :visible.sync="imgPreData.modal" width="800px">
	    <img style="width: 100%; height: auto;" :src="imgPreData.url" alt="">
	  </el-dialog>
	  
  </div>
</template>

<script>
  import {
	//虹软人脸库 分页查询
    getHrFaceDatabasePageList,
	//虹软人脸库新增
	hrFaceDatabaseSaveOrUpdate,
	//人脸比对 1 -> N
	hrFaceComparison
  } from '@/api'

  import HrfaceDatabasePhoto from '@/components/HrFaceDatabasePhoto.vue'

  export default {
    name: 'UserList',	
	components: {HrfaceDatabasePhoto},
    data () {
      return {
        date: [],
        name: '',
        tableData: [],
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
		//性别
		genderList:[{name:"请选择",value:""},{name:"男",value:"1"},{name:"女",value:"0"},{name:"未知",value:"-1"}],
		//二维码logo id
		hrFaceDatabaseId:'',
		// 图片放大
		imgPreData: {
		  modal: false,
		  url: ''
		},
		createTime:'',
		updateTime:'',
		//虹软人脸库
		editData: {
		  modal: false,
		  add: 1,
		  //编号
		  id:'',
		  //姓名
		  name: '',
		  //性别
		  gender:'',
		  //年龄
		  age:'',
		  //人脸图片
		  pictureUrl:'',
		},
      }
    },
    created () {
      this.getHrFaceDatabasePageListFn()
    },
    methods: {
      getHrFaceDatabasePageListFn () {
        this.tableLoading = true
        getHrFaceDatabasePageList({
          pageNum: this.pages.page,
          name: this.name,
          createTime: this.createTime,
          updateTime: this.updateTime
        }).then(res => {
          this.tableData = res.data.records
          this.pages.total = res.data.total
		  console.info(this.tableData,"响应的数据")
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.getHrFaceDatabasePageListFn()
      },
	  //二维码新增或修改
	  addBtn (t) {
	    if (this.editData.add == 1){
	  	  //添加
	  	  this.hrFaceDatabaseSaveOrUpdateFn()
	    } else {
	  	  //修改
	  	  this.hrFaceDatabaseSaveOrUpdateFn()
	    }
	  },
	  //二维码增加或更新
	  hrFaceDatabaseSaveOrUpdateFn(){
	    this.tableLoading = true
	    hrFaceDatabaseSaveOrUpdate({
	  	  id:this.editData.id,
	  	  //名称
	  	  name: this.editData.name,
	  	  //性别
	  	  gender:this.editData.gender,
	  	  //年龄
	  	  age:this.editData.age,
	  	  //图片url
	  	  pictureUrl:this.editData.pictureUrl[0]
	    }).then(res => {
	  	  this.editData.modal = false
	  	  this.$message.success(res.data)
	  	  this.getHrFaceDatabasePageListFn()
	    }).finally(() => {
	      this.tableLoading = false
	    })
	  },
	  editBtn(t,row) {
			//1新增 
			if(t == 1){
				this.editData = {
				modal: true,
				add: 1,
				}
			}else if(t == 2){
				//修改
				this.editData = {
				  modal: true,
				  add: 2,
				  id:row.id,
				  name:row.name,
				  gender:row.gender,
				  age:row.age,
				  pictureUrl:row.pictureUrl
				} 
				this.hrFaceDatabaseId = row.id
			}else if( t == 3 ){
				//人脸比对 1 -> N
				this.tableLoading = true
				hrFaceComparison({
				  id:row.id,
				}).then(res => {
				  this.editData.modal = false
				  this.$message.success(res.data)
				  this.getHrFaceDatabasePageListFn()
				}).finally(() => {
				  this.tableLoading = false
				})	
			}else if( t == 4 ){
				//图片放大
				  this.imgPreData = {
				    modal: true,
					url:row.pictureUrl
				  }
			  }
		}
    }
  }
</script>

<style scoped>

</style>
